import { Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import logo from "../images/amiLogo.jpg";

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 w-full z-50 flex items-center justify-between px-4 md:px-10 py-4 bg-white/90 backdrop-blur-md shadow-sm">
      
      {/* Logo */}
      <img src={logo} alt="logo" className="h-8 md:h-10" />

      {/* Desktop Nav */}
      <nav className="hidden md:flex gap-8 text-gray-700 font-medium">
        <Link to="/platform" className="hover:text-sky-500">Platform</Link>
        <Link to="/infrastructure" className="hover:text-sky-500">Infrastructure</Link>
        <Link to="/sectors" className="hover:text-sky-500">Sectors</Link>
        <Link to="/story" className="hover:text-sky-500">Story</Link>
      </nav>

      {/* Contact Button (Desktop) */}
      <button className="hidden md:block bg-sky-400 text-white px-4 py-2 rounded-md font-semibold hover:bg-sky-500">
        Contact Us
      </button>

      {/* Mobile Menu Icon */}
      <button 
        className="md:hidden text-gray-700"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? <X size={26} /> : <Menu size={26} />}
      </button>

      {/* Mobile Menu */}
     
      {isOpen && (
        <div className="absolute top-full left-0 w-full bg-white shadow-md flex flex-col items-center gap-6 py-6 md:hidden">
          <Link to="/platform" onClick={() => setIsOpen(false)}>Platform</Link>
          <Link to="/infrastructure" onClick={() => setIsOpen(false)}>Infrastructure</Link>
          <Link to="/sectors" onClick={() => setIsOpen(false)}>Sectors</Link>
          <Link to="/story" onClick={() => setIsOpen(false)}>Story</Link>

          <button className="bg-sky-400 text-black px-4 py-2 rounded-md font-semibold hover:bg-sky-500">
            Contact Us
          </button>
        </div>
      )}
    </header>
  );
}

export default Header;